import { Currencies } from './Currencies';

/*
 * @currency = currency code
 * @priceStartBuckets = [array] of every start price of price buckets
 * priceEndSubtractor = number of price end bucket to subtract from price start bucket
 */
const priceRangeFormatter = (
  currency,
  priceStartBuckets = [],
  priceEndSubtractor = 0
) => {
  const priceBuckets = [];
  priceStartBuckets.forEach((priceStart, index) => {
    // create this so if we will insert priceStart to 50,100 the priceEnd of 50 is 99 if we have subtractor of 1
    const priceEndBucket = priceStartBuckets[index + 1] - priceEndSubtractor;
    const isLastIndex = index === priceStartBuckets.length - 1;
    priceBuckets.push({
      id: isLastIndex ? `${priceStart}` : `${priceStart}-${priceEndBucket}`,
      value: isLastIndex
        ? `${currency} ${priceStart}+`
        : `${currency} ${priceStart} - ${currency} ${priceEndBucket}`,
    });
  }, []);

  return priceBuckets;
};

const getPriceFilterOptions = currency => {
  switch (currency) {
    case Currencies.MYR:
      return priceRangeFormatter(Currencies.MYR, [0, 251, 501, 751, 951], 1);
    case Currencies.AUD:
      return priceRangeFormatter(Currencies.AUD, [0, 101, 201, 301, 401], 1);
    case Currencies.CNY:
      return priceRangeFormatter(Currencies.CNY, [0, 401, 801, 1201, 1601], 1);
    case Currencies.EUR:
      return priceRangeFormatter(Currencies.EUR, [0, 51, 101, 151, 201], 1);
    case Currencies.GBP:
      return priceRangeFormatter(Currencies.GBP, [0, 51, 101, 151, 201], 1);
    case Currencies.HKD:
      return priceRangeFormatter(Currencies.HKD, [0, 501, 1001, 1501, 2001], 1);
    case Currencies.JPY:
      return priceRangeFormatter(
        Currencies.JPY,
        [0, 7001, 14001, 21001, 28001],
        1
      );
    case Currencies.NZD:
      return priceRangeFormatter(Currencies.NZD, [0, 101, 201, 301, 401], 1);
    case Currencies.PHP:
      return priceRangeFormatter(
        Currencies.PHP,
        [0, 3001, 6001, 9001, 12001],
        1
      );
    case Currencies.SGD:
      return priceRangeFormatter(Currencies.SGD, [0, 101, 201, 301, 401], 1);
    case Currencies.THB:
      return priceRangeFormatter(
        Currencies.THB,
        [0, 2001, 4001, 6001, 8001],
        1
      );
    case Currencies.USD:
      return priceRangeFormatter(Currencies.USD, [0, 51, 101, 151, 201], 1);
    case Currencies.BDT:
      return priceRangeFormatter(
        Currencies.BDT,
        [0, 5001, 10001, 15001, 20001],
        1
      );
    case Currencies.BND:
      return priceRangeFormatter(Currencies.BND, [0, 101, 201, 301, 401], 1);
    case Currencies.INR:
      return priceRangeFormatter(
        Currencies.INR,
        [0, 4501, 9001, 13501, 18001],
        1
      );
    case Currencies.IDR:
      return priceRangeFormatter(
        Currencies.IDR,
        [0, 800001, 1600001, 2400001, 3200001],
        1
      );
    case Currencies.KRW:
      return priceRangeFormatter(
        Currencies.KRW,
        [0, 70001, 140001, 210001, 280001],
        1
      );
    case Currencies.MOP:
      return priceRangeFormatter(Currencies.MOP, [0, 501, 1001, 1501, 2001], 1);
    case Currencies.TWD:
      return priceRangeFormatter(
        Currencies.TWD,
        [0, 2001, 4001, 6001, 8001],
        1
      );
    case Currencies.VND:
      return priceRangeFormatter(
        Currencies.VND,
        [0, 1500001, 3000001, 4500001, 6000001],
        1
      );
    default:
      return priceRangeFormatter(Currencies.MYR, [0, 251, 501, 751, 951], 1);
  }
};

const getPriceFilterOptionsHotel = currency => {
  switch (currency) {
    case Currencies.MYR:
      return priceRangeFormatter(Currencies.MYR, [0, 151, 301, 451, 601], 1);
    case Currencies.AUD:
      return priceRangeFormatter(Currencies.AUD, [0, 51, 101, 151, 201], 1);
    case Currencies.CNY:
      return priceRangeFormatter(Currencies.CNY, [0, 251, 501, 751, 1001], 1);
    case Currencies.EUR:
      return priceRangeFormatter(Currencies.EUR, [0, 31, 61, 91, 121], 1);
    case Currencies.GBP:
      return priceRangeFormatter(Currencies.GBP, [0, 31, 61, 91, 121], 1);
    case Currencies.HKD:
      return priceRangeFormatter(Currencies.HKD, [0, 301, 601, 901, 1201], 1);
    case Currencies.JPY:
      return priceRangeFormatter(
        Currencies.JPY,
        [0, 4501, 9001, 13501, 18001],
        1
      );
    case Currencies.NZD:
      return priceRangeFormatter(Currencies.NZD, [0, 51, 101, 151, 201], 1);
    case Currencies.PHP:
      return priceRangeFormatter(
        Currencies.PHP,
        [0, 2001, 4001, 6001, 8001],
        1
      );
    case Currencies.SGD:
      return priceRangeFormatter(Currencies.SGD, [0, 51, 101, 151, 201], 1);
    case Currencies.THB:
      return priceRangeFormatter(
        Currencies.THB,
        [0, 1001, 2001, 3001, 4001],
        1
      );
    case Currencies.USD:
      return priceRangeFormatter(Currencies.USD, [0, 31, 61, 91, 121], 1);
    case Currencies.BDT:
      return priceRangeFormatter(
        Currencies.BDT,
        [0, 3001, 6001, 9001, 12001],
        1
      );
    case Currencies.BND:
      return priceRangeFormatter(Currencies.BND, [0, 51, 101, 151, 201], 1);
    case Currencies.INR:
      return priceRangeFormatter(
        Currencies.INR,
        [0, 3001, 6001, 9001, 12001],
        1
      );
    case Currencies.IDR:
      return priceRangeFormatter(
        Currencies.IDR,
        [0, 500001, 1000001, 1500001, 2000001],
        1
      );
    case Currencies.KRW:
      return priceRangeFormatter(
        Currencies.KRW,
        [0, 50001, 100001, 150001, 200001],
        1
      );
    case Currencies.MOP:
      return priceRangeFormatter(Currencies.MOP, [0, 301, 601, 901, 1201], 1);
    case Currencies.TWD:
      return priceRangeFormatter(
        Currencies.TWD,
        [0, 1001, 2001, 3001, 4001],
        1
      );
    case Currencies.VND:
      return priceRangeFormatter(
        Currencies.VND,
        [0, 800001, 1600001, 2400001, 3200001],
        1
      );
    default:
      return priceRangeFormatter(Currencies.MYR, [0, 151, 301, 451, 601], 1);
  }
};
const getPriceFilterOptionsConfing = (currency, priceRange) => {
  return priceRangeFormatter(currency, priceRange, 1);
};

export {
  getPriceFilterOptions,
  getPriceFilterOptionsHotel,
  getPriceFilterOptionsConfing,
};
